import { FC, InputHTMLAttributes } from 'react';
import { Container, Control } from './Switch.styles';

interface SwitchProps extends InputHTMLAttributes<HTMLInputElement> {
	label: string;
}

const Switch: FC<SwitchProps> = ({ checked, onChange, name, label }) => {
	return (
		<Container>
			<Control type='checkbox' checked={checked} onChange={onChange} name={name} />
			<span>{label}</span>
		</Container>
	);
};

export default Switch;
